import type { ComponentChildren, Ref } from 'preact';

interface Props {
  width: number;
  height: number;
  canvasRef: Ref<HTMLCanvasElement>;
  alt: string;
  children?: ComponentChildren;
}

/**
 * The photo area: keeps the photo's aspect ratio, fits the width, and caps the
 * height so controls stay in view on phones. Layers stack on top of the canvas.
 */
export function FloorStage({ width, height, canvasRef, alt, children }: Props) {
  const ratio = width / height;
  return (
    <div
      class="relative mx-auto w-full overflow-hidden bg-black sm:rounded-2xl"
      style={{ aspectRatio: `${width} / ${height}`, maxWidth: `calc(min(var(--fv-vh) * 64, 720px) * ${ratio})` }}
    >
      <canvas ref={canvasRef} role="img" aria-label={alt} class="absolute inset-0 h-full w-full" />
      {children}
    </div>
  );
}
